//@flow

import env from '../../environment';
import {getCreator, putCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_CUSTOMER_COMPLAINT: `${env.baseApiUrl}/winehouse/admin/customer-complaint/:customerComplaintId`,
  GET_CUSTOMER_COMPLAINTS: `${env.baseApiUrl}/winehouse/admin/customer-complaint`,
  UPDATE_CUSTOMER_COMPLAINT: `${env.baseApiUrl}/winehouse/admin/customer-complaint/:customerComplaintId`,
  GET_CUSTOMER_COMPLAINT_SETTING: `${env.baseApiUrl}/winehouse/admin/customer-complaint/setting`,
  CREATE_OR_EDIT_CUSTOMER_COMPLAINT_SETTING: `${env.baseApiUrl}/winehouse/admin/customer-complaint/setting`,
});

export const getCustomerComplaintApi = getCreator(
  endpoints.GET_CUSTOMER_COMPLAINT
);
export const getCustomerComplaintsApi = getCreator(
  endpoints.GET_CUSTOMER_COMPLAINTS
);
export const updateCustomerComplaintApi = putCreator(
  endpoints.UPDATE_CUSTOMER_COMPLAINT
);

export const getCustomerComplaintSettingApi = getCreator(
  endpoints.GET_CUSTOMER_COMPLAINT_SETTING
);
export const createOrEditCustomerComplaintSettingApi = postCreator(
  endpoints.CREATE_OR_EDIT_CUSTOMER_COMPLAINT_SETTING
);
